export default __webpack_public_path__ + "static/media/timeframeIcon.949ca041.svg";